// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel.discriminator = undefined;
EnterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel.additionalProperties = false;
EnterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel.attributeTypeMap = [
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    },
    {
        "name": "relatedId",
        "baseName": "relatedId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    },
];
//# sourceMappingURL=enterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel.js.map